import ExternalPersonnelManagementPage from './ExternalPersonnelManagement/ExternalPersonnelManagementPage';

export default ExternalPersonnelManagementPage;
